import { useState } from "react";
import { useLocation } from "wouter";
import { Menu, X, LogOut, Upload } from "lucide-react";
import type { User } from "../../types";
import { useIsMobile } from "../../hooks/useIsMobile";

interface Props {
  user: User;
  onLogout: () => void;
  onUpload: () => void;
  hideUpload?: boolean;
}

export function TopNav({ user, onLogout, onUpload, hideUpload }: Props) {
  const [location, navigate] = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useIsMobile();

  const go = (path: string) => {
    navigate(path);
    setMenuOpen(false);
  };

  const activeLinkStyle: React.CSSProperties = { color: "#fff", fontWeight: 600, textDecoration: "none", fontSize: "0.9rem" };
  const inactiveLinkStyle: React.CSSProperties = { color: "#94a3b8", fontWeight: 400, textDecoration: "none", fontSize: "0.9rem" };

  if (isMobile) {
    return (
      <nav style={{ background: "#1d4ed8", padding: "0.75rem 1rem", display: "flex", alignItems: "center", position: "relative" }}>
        <span style={{ color: "#fff", fontWeight: 700, fontSize: "1.1rem", flex: 1 }}>£ Expenses</span>
        <button
          onClick={() => setMenuOpen(o => !o)}
          style={{ background: "none", border: "none", color: "#fff", fontSize: "1.5rem", cursor: "pointer", padding: "0.25rem 0.5rem", lineHeight: 1 }}
          aria-label="Menu"
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        {menuOpen && (
          <>
            <div
              style={{ position: "fixed", inset: 0, zIndex: 49 }}
              onClick={() => setMenuOpen(false)}
            />
            <div style={{
              position: "absolute", top: "100%", left: 0, right: 0,
              background: "#1e3a8a", zIndex: 50, boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            }}>
              <a href="/" onClick={e => { e.preventDefault(); go("/"); }}
                style={{ display: "block", padding: "0.875rem 1.25rem", ...(location === "/" ? activeLinkStyle : inactiveLinkStyle), borderBottom: "1px solid #1d4ed833" }}>
                Receipts
              </a>
              <a href="/settings" onClick={e => { e.preventDefault(); go("/settings"); }}
                style={{ display: "block", padding: "0.875rem 1.25rem", ...(location === "/settings" ? activeLinkStyle : inactiveLinkStyle), borderBottom: "1px solid #1d4ed833" }}>
                Settings
              </a>
              {!hideUpload && (
                <button onClick={() => { onUpload(); setMenuOpen(false); }}
                  style={{ display: "flex", alignItems: "center", gap: "0.5rem", width: "100%", padding: "0.875rem 1.25rem", background: "none", border: "none", textAlign: "left", color: "#bfdbfe", cursor: "pointer", fontSize: "0.9rem", borderBottom: "1px solid #1d4ed833" }}>
                  <Upload size={16} /> Upload receipt
                </button>
              )}
              <div style={{ padding: "0.75rem 1.25rem", borderBottom: "1px solid #1d4ed833" }}>
                <div style={{ color: "#93c5fd", fontSize: "0.8rem" }}>{user.email}</div>
              </div>
              <button onClick={() => { onLogout(); setMenuOpen(false); }}
                style={{ display: "flex", alignItems: "center", gap: "0.5rem", width: "100%", padding: "0.875rem 1.25rem", background: "none", border: "none", textAlign: "left", color: "#f87171", cursor: "pointer", fontSize: "0.875rem" }}>
                <LogOut size={16} /> Sign out
              </button>
            </div>
          </>
        )}
      </nav>
    );
  }

  return (
    <nav style={{ background: "#1d4ed8", padding: "0.75rem 1.5rem", display: "flex", alignItems: "center", gap: "1.5rem" }}>
      <span style={{ color: "#fff", fontWeight: 700, fontSize: "1.1rem", marginRight: "auto" }}>£ Expenses</span>
      <a style={location === "/" ? activeLinkStyle : inactiveLinkStyle} href="/" onClick={e => { e.preventDefault(); navigate("/"); }}>Receipts</a>
      <a style={location === "/settings" ? activeLinkStyle : inactiveLinkStyle} href="/settings" onClick={e => { e.preventDefault(); navigate("/settings"); }}>Settings</a>
      {!hideUpload && (
        <button onClick={onUpload}
          style={{ background: "#fff", color: "#1d4ed8", border: "none", borderRadius: "4px", padding: "0.375rem 0.875rem", fontWeight: 600, cursor: "pointer" }}>
          + Upload
        </button>
      )}
      <span style={{ color: "#bfdbfe", fontSize: "0.8rem" }}>{user.email}</span>
      <button onClick={onLogout} style={{ display: "flex", alignItems: "center", gap: "0.375rem", background: "none", border: "1px solid #3b82f6", color: "#93c5fd", borderRadius: "4px", padding: "0.25rem 0.75rem", cursor: "pointer", fontSize: "0.8rem" }}>
        <LogOut size={14} /> Sign out
      </button>
    </nav>
  );
}
